import React from "react";
import { Typography, Image } from "antd";

const { Title, Paragraph } = Typography;

const NewBusinessDevelopment = () => {
  return (
    <div>
      <div>
        <Title level={1}>New Business Development (NBD)</Title>
      </div>
      <Image
        src="/images/new-biz-dev-hero.jpg"
        alt="new business development"
        preview={false}
      />
      <div>
        <Paragraph className="common-paragraph">
          TEMA New Business Development (NBD) commercializes Chevron Downstream technologies that are
          outside of the existing CLG and ART businesses.
        </Paragraph>
      </div>
      <div>
        <Title level={2}>Technologies that are commercially available now</Title>
      </div>
      <div>
      <ul className="common-paragraph">
        <li>
          GTL/CTL – hydroprocessing units following Fischer-Tropsch units in gas-to-liquids or coal-to-liquids process to produce fuel products and base oil products
        </li>
        <li>
          <a href="newBusinessDevelopment/mercaway">MERCAWAY&#8480;</a> – commercially proven mercury removal process for crudes or condensates
        </li>
        <li>
          ISOALKY™ – first successful liquid Alkylation process in 75 years to produce high-octane fuel blending component for cleaner-burning fuels
        </li>
        <li>
          ICR® 1000 – ultra-high-activity catalysts for hydrocracking pretreat, FCC pretreat and diesel hydrotreating applications
        </li>
        <li>
          New Materials/Catalysts – license of proprietary materials and catalysts such as Chabazite
        </li>
      </ul>
      </div>
      <div>
        <Title level={2}>Technologies that are currently under development</Title>
      </div>
      <ul className="common-paragraph">
        <li>
          Production of Chevron's proprietary diesters for premium lube formulations
        </li>
      </ul>
      <div>
      <Paragraph className="common-paragraph">
        In addition to the above commercialization activities, NBD has an active IP monetization
        program to continually evaluate Chevron's extensive portfolio of Intellectual Property to
        identify patents and know-how that can be made available for license to third parties.
      </Paragraph>
      <Paragraph className="common-paragraph">
        If you have questions about any of the above technologies, please send your requests to:{" "}
        <a href="mailto:techma@chevron.com">techma@chevron.com</a>
      </Paragraph>
      </div>
    </div>
  );
};

export default NewBusinessDevelopment;